<template>
<div class="home">
<!--  轮播-->
  <div class="swiper">
    <el-carousel height="60rem" :interval="6000" loop>
      <el-carousel-item>
        <el-row>
          <el-col :span="12">
            <h3>
              <span style="
                font-size: 5rem;
                color: #fd3335;
                border-right: 0.3rem solid #d8d8d8;
                padding-right: 1rem;
                margin-right: 1rem;
                display: inline-block;
                height: 5rem;
                line-height: 5rem;
                vertical-align: middle;
                ">云创
              </span>
              <span style="vertical-align: middle;color: #020b1a;">智慧差旅</span>
            </h3>
            <h4>
              技术赋能的差旅管理新范式
            </h4>
            <h5>
              智慧差旅是以数字化技术为核心，整合 “预订、审批、消费、报销、数据分析” 全流程的一体化差旅管理方案。它通过打通企业政策、供应商资源与员工需求，实现 “降本、提效、合规、优化体验” 四大核心目标，是企业数字化转型在行政后勤领域的典型应用。
            </h5>
            <img src="./../../../assets/home/btn.png" style="width: 16rem; margin-top: 5rem; cursor: pointer">
          </el-col>
          <el-col :span="12">
            <img src="../../../assets/home/cl-banner.png" style="margin-left: 1rem; width:100%;">
          </el-col>
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <el-row>
          <el-col :span="12">
            <h3>
              <span style="
                font-size: 5rem;
                color: #fd3335;
                border-right: 0.3rem solid #d8d8d8;
                padding-right: 1rem;
                margin-right: 1rem;
                display: inline-block;
                height: 5rem;
                line-height: 5rem;
                vertical-align: middle;
                ">云创
              </span>
              <span style="vertical-align: middle;color: #020b1a;">项目管理</span>
            </h3>
            <h4>
              核心价值：降本、提效、控风险
            </h4>
            <h5>
              专为工程领域设计的数字化工具，通过整合项目全生命周期的 “进度、成本、资源、质量、安全、文档” 等核心要素，实现项目从规划、执行、监控到收尾的标准化、可视化、协同化管理，最终解决工程行业 “信息碎片化、沟通效率低、风险难管控” 等痛点。
            </h5>
            <img src="./../../../assets/home/btn.png" style="width: 16rem; margin-top: 5rem; cursor: pointer">
          </el-col>
          <el-col :span="12">
            <img src="../../../assets/home/xmgl-banner.png" style="margin-left: 1rem; width:100%;">
          </el-col>
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <el-row>
          <el-col :span="12">
            <h3>
              <span style="
                font-size: 5rem;
                color: #fd3335;
                border-right: 0.3rem solid #d8d8d8;
                padding-right: 1rem;
                margin-right: 1rem;
                display: inline-block;
                height: 5rem;
                line-height: 5rem;
                vertical-align: middle;
                ">云创
              </span>
              <span style="vertical-align: middle;color: #020b1a;">OA管理</span>
            </h3>
            <h4>
              以 “协同” 为核心    以 “效率” 为目标
            </h4>
            <h5>
              基于计算机、网络和信息化技术，实现企业日常办公流程数字化、信息共享协同化、管理决策智能化的核心工具。目标是打破信息孤岛、规范办公流程、提升协作效率，将传统纸质化、分散化的办公模式升级为数字化、集中化的协同平台，适用于各类规模的企业与组织。
            </h5>
            <img src="./../../../assets/home/btn.png" style="width: 16rem; margin-top: 5rem; cursor: pointer">
          </el-col>
          <el-col :span="12">
            <img src="../../../assets/home/oagl-banner.png" style="margin-left: 1rem; width:100%;">
          </el-col>
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <el-row>
          <el-col :span="12">
            <h3>
              <span style="
                font-size: 5rem;
                color: #fd3335;
                border-right: 0.3rem solid #d8d8d8;
                padding-right: 1rem;
                margin-right: 1rem;
                display: inline-block;
                height: 5rem;
                line-height: 5rem;
                vertical-align: middle;
                ">云创
              </span>
              <span style="vertical-align: middle;color: #020b1a;">人力资源管理</span>
            </h3>
            <h4>
              数字化管理人才  智能化支持战略决策
            </h4>
            <h5>
              企业数字化转型的核心工具，通过整合招聘、考勤、薪酬、绩效等全流程模块，实现人力资源管理的自动化、智能化与数据驱动。企业可实现 HR 效率提升 60% 以上、人力成本降低 30%，同时增强员工体验与组织敏捷性，在数字化时代的人才竞争中占据先机。
            </h5>
            <img src="./../../../assets/home/btn.png" style="width: 16rem; margin-top: 5rem; cursor: pointer">
          </el-col>
          <el-col :span="12">
            <img src="../../../assets/home/rlzy-banner.png" style="margin-left: 1rem; width:100%;">
          </el-col>
        </el-row>
      </el-carousel-item>
      <el-carousel-item>
        <el-row>
          <el-col :span="12">
            <h3>
              <span style="
                font-size: 5rem;
                color: #fd3335;
                border-right: 0.3rem solid #d8d8d8;
                padding-right: 1rem;
                margin-right: 1rem;
                display: inline-block;
                height: 5rem;
                line-height: 5rem;
                vertical-align: middle;
                ">云创
              </span>
              <span style="vertical-align: middle;color: #020b1a;">数字化底座</span>
            </h3>
            <h4>
              承上启下   连接 “技术” 与 “业务”
            </h4>
            <h5>
              数字化底座是企业或组织开展全面数字化转型的核心基础架构，通过整合底层技术、数据、应用能力，构建一个 “统一、灵活、可复用” 的技术平台，为上层业务场景提供稳定、高效的支撑。它是一套 “技术 + 数据 + 能力” 的整合体系。
            </h5>
            <img src="./../../../assets/home/btn.png" style="width: 16rem; margin-top: 5rem; cursor: pointer">
          </el-col>
          <el-col :span="12">
            <img src="../../../assets/home/szdz-banner.png" style="margin-left: 1rem; width:100%;">
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>

  </div>
  <!--  六大核心价值-->
  <div class="wrap" style="padding: 6rem 0">
    <div class="el-row home2" >
      <el-col :span="4">
        <h5>低代码开发</h5>
        <h6>LOW CODE DEVELOPMENT</h6>
      </el-col>
      <el-col :span="4">
        <h5>数字化底座</h5>
        <h6>DIGITAL BASE</h6>
      </el-col>
      <el-col :span="4">
        <h5>国产化适配</h5>
        <h6>DOMESTICATED ADAPTATION</h6>
      </el-col>
      <el-col :span="4">
        <h5>大屏设计器</h5>
        <h6>LARGE SCREEN DESIGNER</h6>
      </el-col>
      <el-col :span="4">
        <h5>工作流引擎</h5>
        <h6>WORKFLOW ENGINE</h6>
      </el-col>
      <el-col :span="4">
        <h5>开发 对接 IOT</h5>
        <h6>LOW CODE DEVELOPMENT</h6>
      </el-col>
    </div>
  </div>
<!--低代码开发-->
  <section class="home3">
    <div class="wrap" >
      <div class="name">低代码开发</div>
      <div class="tablist" style="border-radius: 5px">
        <div class="tabspan" style="border-radius: 5px 5px 0 0">
          <span v-for="(item,index) in tabspanList" :key="index" :class="{action:tabspantext===item.name}" @click="tabclick(item)">{{item.name}}</span>
        </div>
        <div class="tabbox">
          <div v-for="(item,index) in tabspanList" :key="index +'s'" v-show="tabspantext===item.name">
            <img :src="require('../../../assets/'+item.img)" width="100%">
          </div>
        </div>
      </div>
    </div>
  </section>
<!--  数字化底座-->
  <section class="home4">
    <div class="wrap" >
      <div class="name">数字化底座</div>
      <img src="../../../assets/home/home9.png" style="width: 80%; margin: auto">
    </div>
  </section>
<!--  国产化适配-->
  <section class="home5">
    <div class="wrap" >
      <div class="name">国产化适配</div>
      <img src="../../../assets/home/home10.png" style="width: 80%; margin: auto">
    </div>
  </section>
  <!--  支持微信、钉钉、APP-->
  <section class="home6">
    <div class="wrap" >
      <div class="name">支持微信、钉钉、APP</div>
      <img src="../../../assets/home/home18.png" style="width: 80%; margin: auto">
    </div>
  </section>
<!--  可视化大屏设计器-->
  <section  class="home7">
    <div class="wrap" >
      <div class="name">可视化大屏设计器</div>
      <video :controls="controls1" src="../../../assets/home/sp1.mp4"  id="videoId" v-show="controls1" style="width: 100%;border-radius: 5px"></video>
      <img src="../../../assets/home/home11.png" width="100%" v-if="!controls1" @click="sp1click" style="cursor: pointer; border-radius: 5px">
    </div>
  </section>
<!--  工作流引擎-->
  <section  class="home8">
    <div class="wrap" >
      <div class="name">工作流引擎</div>
      <video :controls="controls2" src="../../../assets/home/sp2.mp4"  id="videoId2" v-show="controls2" style="width: 100%;border-radius: 5px"></video>
      <img src="../../../assets/home/home12.png" width="100%" v-if="!controls2" @click="sp2click" style="cursor: pointer;border-radius: 5px">
    </div>
  </section>
<!--  开放、对接、IOT-->
  <section   class="home9">
    <div class="wrap">
      <div class="name">开放、对接、IOT</div>
      <img src="../../../assets/home/home13.png" style="width: 80%; margin: auto">
    </div>
  </section>
</div>
</template>

<script>
import "swiper/swiper-bundle.min.css";
export default {
  name: "homeIndex",
  components: {
  },
  data(){
    return {
        home1:{},
      swiperimgData:[
        {
          name:'图片1',
          url:'home/home1.png'
        }
      ],
      tabspantext:'平台架构',
      tabspanList:[
        {
          name:'平台架构',
          img:'home/home8.png'
        },
        {
          name:'功能引擎',
          img:'home/home14.png'
        }
        ,{
          name:'流程引擎',
          img:'home/home16.png'
        },{
          name:'资源库',
          img:'home/home17.png'
        },
        {
          name:'脚本工具',
          img:'home/home15.png'
        }
      ],
      controls1:false,
    controls2:false,

    }
  },
  mounted() {
  },
  methods:{
    tabclick(val){
      this.tabspantext=val.name
    },
    sp1click(){
      let videoElement=document.getElementById("videoId")
      this.controls1=true
      videoElement.play();
    },
    sp2click(){
      let videoElement=document.getElementById("videoId2")
      this.controls2=true
      videoElement.play();
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper{
  width: 100%;
  background: url('../../../assets/home/home1bg.png') no-repeat; background-size: 100% 100%;
  .el-row{
    width: 120rem;
    min-width: 120rem;
    padding: 5rem 0 10rem 0;
    margin: auto;
    h3{
      span{
        font-size: 5rem;
      }
      margin-bottom: 4rem;
    }
    h4{
      font-size: 3.5rem;
      margin-bottom: 4rem;
      letter-spacing: 2px;
      color: #020b1a;
    }
    h5{
      padding-right: 2rem;
      font-size: 2rem;
      font-weight: 400;
      color: #444955;
      line-height: 40px;
    }
  }
}
.home{
  padding-top: 6.4rem;
}
.wrap{
  min-width: 120rem;
  width: 120rem;
  padding:10rem 0 10rem;
  margin: auto;
  //height: calc(100vh - 10rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  .name{
    font-weight: 800;
    color: #ED0200;
    line-height: 2.8rem;
    font-size: 2.8rem;
    letter-spacing: 4px;
    text-align: center;
    margin-bottom: 6rem;
  }
  .imglist{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .imgbox{
      width: 37.2rem;
      height: 28rem;
      margin-bottom: 3.6rem;
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      //box-shadow: 0px .3rem 1rem 0rem rgba(0,0,0,0.2);
      border-radius: .4rem;
      background: #fff;
      align-items: center;
      img{
        width: 10.8rem;
        margin-top: 5rem;
      }
      span{
        font-size: 2.4rem;
        margin-top: 3.2rem;
      }

    }
  }
  .tablist{
  width: 100%;
  background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.08);
    border-radius: 10px;
    .tabspan{
      background:#fff;
      height: 6.4rem;
      line-height: 6.4rem;
      display: flex;
      justify-content: space-around;
      span{
        font-weight: 400;
        color: #444955;
        font-size: 2rem;
        position: relative;
        cursor: pointer;
        &.action{
          //font-size: 2.4rem;
          font-weight: 500;
          color: #FD3335;
          &::after{
            content: '';
            position: absolute;
            height: .2rem;
            width: 100%;
            background: #FD3335;
            left: 0;
            bottom: 0;
          }
        }
      }
    }
    .tabbox{
      padding: 4rem;
    }
}
  .home2{
    height: 20rem;
    background: url('../../../assets/home/home2bg.png') no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    padding: 0 30px;
    h5{font-size: 2rem;color: rgba(255,255,255,1);margin-bottom: 5px }
    h6{font-size:1.2rem; color: rgba(255,255,255,.6); font-weight: 100}
  }

}
.home3{
  background: url('../../../assets/home/home8bg.png') no-repeat;background-size: cover;
}
.home4{
  background: url('../../../assets/home/home9bg.png') no-repeat;background-size: cover;
}
.home5{
  background: url('../../../assets/home/home10bg.png') no-repeat;background-size: cover;
}
.home6{
  background: url('../../../assets/home/home18bg.png') no-repeat;background-size: cover;
}
.home7{
  background: url('../../../assets/home/home11bg.png') no-repeat;background-size: cover;
}
.home8{
  background: url('../../../assets/home/home12bg.png') no-repeat;background-size: cover;
}
.home9{
  background: url('../../../assets/home/home13bg.png') no-repeat;background-size: cover;
}
</style>
